// Packs a given value into an array if it's not already an array
const pack = <T>(v: T | T[]): T[] => (Array.isArray(v) ? v : [v]);

export default pack;
